jQuery(document).ready(function(){

  function resizeInstagram() {
    
    if ( jQuery('#insta-feed .container').length ) {
      $width = jQuery('#insta-feed').width();
      $quarter = $width/4;
      jQuery('#insta-feed .container, #insta-feed .container img').width($quarter).height($quarter);
    } else {
      setTimeout(resizeInstagram, 100); // repeat until insta-feed loads
    }
  }
  
  resizeInstagram();

  jQuery(window).resize(resizeInstagram);
});
